module.exports = __webpack_public_path__ + "img/quick-label-print-icon.753237a1.svg";